export default __webpack_public_path__ + "static/media/electronics.b3073c8b.svg";